export default "__VITE_ASSET__y$T$kK3J__"